/** Editor i18n catalog: common (spec #304). English is the key source; German uses "du" and real umlauts. */
import { defineMessages } from "../core.ts";

export const common = defineMessages(
  {
    loading: "Loading…",
    somethingWrong: "Something went wrong",
    networkError: "Network error. Check your connection and try again.",
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    close: "Close",
    remove: "Remove",
    search: "Search…",
    filter_options: "Filter options",
    no_matches: "No matches",
    // Relative times ("in 3h", "5h ago", "in 2d"): coarse and timezone-free on purpose.
    inUnderHour: "in under an hour",
    underHourAgo: "under an hour ago",
    inHours: "in {n}h",
    hoursAgo: "{n}h ago",
    inDays: "in {n}d",
    daysAgo: "{n}d ago",
  },
  {
    loading: "Lädt…",
    somethingWrong: "Etwas ist schiefgelaufen",
    networkError: "Netzwerkfehler. Prüf deine Verbindung und versuch es noch mal.",
    save: "Speichern",
    saving: "Speichert…",
    cancel: "Abbrechen",
    close: "Schließen",
    remove: "Entfernen",
    search: "Suchen…",
    filter_options: "Optionen filtern",
    no_matches: "Keine Treffer",
    inUnderHour: "in weniger als einer Stunde",
    underHourAgo: "vor weniger als einer Stunde",
    inHours: "in {n} Std.",
    hoursAgo: "vor {n} Std.",
    inDays: "in {n} Tagen",
    daysAgo: "vor {n} Tagen",
  },
);
